import { Form } from 'react-bootstrap';
import React from 'react';

export const DropdownSelect = ({ id, title, onSelect, data }) => {
    return (
        <div className={'dropdown-selection-block'}>
            {title !== null ? (<div>{title}</div>) : (<></>)}
            <Form.Select
                id={id}
                onChange={(e) => onSelect(+e.target.value)}
            >
                {data.map((it) => {
                    return (
                        <option value={it.id} key={it.name}>
                            {it.name}
                        </option>
                    );
                })}
            </Form.Select>
        </div>
    );
};